/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Thresholds_Threshold_PaceInputs */

const en_ui_thresholds_threshold_pace = /** @type {(inputs: Ui_Thresholds_Threshold_PaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Threshold Pace (min/km)`)
};

const de_ui_thresholds_threshold_pace = /** @type {(inputs: Ui_Thresholds_Threshold_PaceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Schwellentempo (min/km)`)
};

/**
* | output |
* | --- |
* | "Threshold Pace (min/km)" |
*
* @param {Ui_Thresholds_Threshold_PaceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_thresholds_threshold_pace = /** @type {((inputs?: Ui_Thresholds_Threshold_PaceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Thresholds_Threshold_PaceInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_thresholds_threshold_pace(inputs)
	return de_ui_thresholds_threshold_pace(inputs)
});